var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v(_vm._s(_vm.params.data.patient.dob ? _vm.calculateAge(_vm.params.data.patient.dob) : 'N/A')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }